var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"btn-icon btn-round fab",attrs:{"size":"lg"},on:{"click":_vm.handle}},[_c('i',{staticClass:"fa fa-plus"})])}
var staticRenderFns = []

export { render, staticRenderFns }